/**
 * Tutorial guidato dell'elenco Comunicazioni.
 *
 * Il piu' in alto e i tre pallini della riga si raccontano illuminando il pulsante,
 * non la voce dentro il menu: aprire un menu di Vuetify dal tutorial non e'
 * affidabile, perche' il click programmatico e quello su "Avanti" arrivano a
 * `document` a un soffio di distanza e il menu appena aperto legge il secondo come
 * un click fuori. Il pulsante invece c'e' sempre, e il testo dice cosa contiene.
 *
 * Il tutorial non preme il piu': porterebbe via dalla pagina.
 *
 * Chi ha il ruolo in sola lettura non vede il piu' ne' il filtro destinatario: il passo
 * del piu' si salta da solo.
 */
const SCOPE = '[data-tour-scope="messages"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createMessagesTourSteps() {
	return [
		{
			body: 'Queste sono le comunicazioni interne fra chi usa il gestionale: avvisi, circolari, messaggi al personale. Non hanno niente a che vedere con le mail ai clienti - restano dentro il gestionale, e chi le riceve le trova qui al suo accesso.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Le comunicazioni interne',
		},
		{
			body: "Il piu' in alto apre la pagina della comunicazione nuova: destinatari, titolo e testo. La pagina ha un tutorial suo, e Annulla riporta qui.",
			key: 'add',
			missing: 'skip',
			placement: 'left',
			target: at('add'),
			title: 'Scrivere una comunicazione',
		},
		{
			body: "I filtri stanno sopra l'elenco: il destinatario e se la comunicazione e' gia' stata letta. Restano nell'indirizzo della pagina: un refresh, o il ritorno da una scheda, li ritrova come li avevi lasciati.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Filtrare le comunicazioni',
		},
		{
			body: "La tabella mostra la data di invio, il titolo, chi ha scritto, chi ha ricevuto e se e' stata letta. Una riga per destinatario: mandando lo stesso messaggio a cinque persone, qui compaiono cinque righe, una per ognuna.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "Questa colonna dice se il destinatario ha aperto la comunicazione, con il giorno e l'ora: verde letta, rossa ancora da leggere. E' il modo per sapere se un avviso e' arrivato davvero a destinazione, senza doverlo chiedere.",
			key: 'read',
			placement: 'left',
			target: at('read'),
			title: 'Chi ha letto e quando',
		},
		{
			body: "I tre pallini a inizio riga raccolgono le azioni della comunicazione: Modifica apre la sua pagina, Elimina la cancella dopo una conferma. Chi ha il ruolo in sola lettura trova al loro posto Visualizza: apre la pagina per leggerla, e da quel momento risulta letta.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Aprire una comunicazione',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
